"use client";
import React, { useState } from "react";
import { Table, TableBody, TableCell, TableHeader, TableRow } from "../../../../components/ui/table";
import Checkbox from "../../../../components/form/input/Checkbox";

// Interface for the table row data
interface TableRowData {
  id: string; 
  name: string; // Venue's full name
  inventories: string; // Inventory status
  parLevel: string; // Par level for the product
}

const tableRowData: TableRowData[] = [
  {
    id: "",
    name: "Brighton Lakes Recreation and Golf Club",
    inventories: "Yes",
    parLevel: "10",
  
  },
  {
    id: "",
    name: "Castle Hill RSL Club",
    inventories: "Yes",
    parLevel: "10",
  
  },
  {
    id: "",
    name: "Catering HQ Logistics",
    inventories: "Yes",
    parLevel: "10",
  
  },
];

export default function Venue() {
  const [selectedRows, setSelectedRows] = useState<string[]>([]);
  const [selectAll, setSelectAll] = useState<boolean>(false);

  const handleSelectAll = () => {
    setSelectAll(!selectAll);
    if (!selectAll) {
      setSelectedRows(tableRowData.map((row) => row.id));
    } else {
      setSelectedRows([]);
    }
  };

  const handleRowSelect = (id: string) => {
    setSelectedRows((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((rowId) => rowId !== id)
        : [...prevSelected, id]
    );
  };
  return (
    <div className="overflow-hidden rounded-2xl border border-gray-200 bg-white pt-4 dark:border-white/[0.05] dark:bg-white/[0.03]">
      <div className="flex flex-col gap-4 px-6 mb-4 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <p className="text-base font-semibold text-gray-800 dark:text-white/90">
            Select Venues to order.
          </p>
        </div>
      </div>
      <div className="max-w-full overflow-x-auto">
        <div className="min-w-[617px] 2xl:min-w-[808px]">
            <Table>
              <TableHeader className="px-6 py-3.5 border-t border-gray-100 border-y bg-gray-50 dark:border-white/[0.05] dark:bg-gray-900">
                <TableRow>
                  <TableCell className="px-6 py-3 font-medium text-gray-700 sm:px-6 text-theme-xs dark:text-gray-400 text-start">
                    Venues
                  </TableCell>
                  <TableCell className="px-6 py-3 font-medium text-gray-700 sm:px-6 text-theme-xs dark:text-gray-400 text-start">
                    <div className="flex items-center gap-3">
                      <div>
                        <Checkbox
                        checked={selectAll}
                        onChange={handleSelectAll}
                        />
                      </div>
                        Avaiable in all venues
                    </div>
                  </TableCell>
                  <TableCell className="px-6 py-3 font-medium text-gray-700 sm:px-6 text-theme-xs dark:text-gray-400 text-start">
                    Keep in Inventories
                  </TableCell>
                  <TableCell className="px-6 py-3 font-medium text-gray-700 sm:px-6 text-theme-xs dark:text-gray-400 text-start">
                    Par Level
                  </TableCell>
                </TableRow>
              </TableHeader>
              <TableBody>
                  {tableRowData.map((row: TableRowData) => (
                  <TableRow key={row.id}>
                      
                      <TableCell className="px-4 sm:px-6 py-3.5">
                      <div className="flex items-center gap-3">
                        <div>
                          <span className="text-gray-500 text-theme-sm dark:text-gray-400">
                            {row.name}
                          </span>
                        </div>
                      </div>
                      </TableCell>
                      <TableCell className="px-4 sm:px-6 py-3.5">
                        <div className="flex items-center gap-3">
                          <div>
                          <Checkbox
                              checked={selectedRows.includes(row.name)}
                              onChange={() => handleRowSelect(row.name)}
                          />
                          </div>
                        </div>
                      </TableCell>
                      <TableCell className="px-4 sm:px-6 py-3.5">
                      <p>
                      <Checkbox
                              checked={selectedRows.includes(row.id)}
                              onChange={() => handleRowSelect(row.id)}
                          />
                      </p>
                      </TableCell>
                      <TableCell className="px-4 sm:px-6 py-3.5">
                      <p className="text-gray-500 text-theme-sm dark:text-gray-400">
                      <input
												type="text"
												value={row.parLevel}
												className="text-gray-500 text-theme-sm dark:text-gray-400 border rounded"
                    	/>
                      </p>
                      </TableCell>
                  </TableRow>
                  ))}
              </TableBody>
            </Table>
        </div>
      </div>
    </div>
  );
}
